import { Button } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type PillButtonProps = {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  px?: number;
  py?: number;
  bg?: string;
};

export function PillButton({
  label,
  onClick,
  disabled = false,
  fullWidth = false,
  px,
  py,
  bg,
}: PillButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      radius="9999"
      size="md"
      fw={FONT_WEIGHTS.semibold}
      styles={theme => ({
        root: {
          height: py !== undefined ? 'auto' : 48,
          paddingLeft: px ?? 16,
          paddingRight: px ?? 16,
          paddingTop: py,
          paddingBottom: py,
          borderRadius: 9999,
          fontSize: theme.fontSizes.md,

          backgroundColor: disabled ? theme.colors.gray[2] : (bg ?? theme.colors.brand[6]),

          cursor: disabled ? 'not-allowed' : 'pointer',

          '&:hover': {
            backgroundColor: disabled ? theme.colors.gray[2] : theme.colors.brand[7],
          },
        },
        label: {
          color: disabled ? theme.colors.gray[6] : theme.white,
        },
      })}
    >
      {label}
    </Button>
  );
}
